import axios from 'axios';

const API_KEY = process.env.REACT_APP_RAPID_API_WEATHER_API_KEY;
const HOST = 'community-open-weather-map.p.rapidapi.com';

export const getForecast = async ({ lat, lng }) => {
  if (!API_KEY || !lat || !lng) return { list: [] };
  try {
    const { data } = await axios.get(`https://${HOST}/forecast`, {
      params: { lat, lon: lng },
      headers: {
        'x-rapidapi-key': API_KEY,
        'x-rapidapi-host': HOST,
      },
    });
    return data || { list: [] };
  } catch (error) {
    console.error('getForecast failed', error?.response?.status || error?.message);
    return { list: [] };
  }
};
